import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, actions, constants } from '..';
import { makeGet } from '../../../api/ajax';

// Module-level (not per-component) guard: experimental features are a single global resource,
// so when multiple components mount this hook at once, only one of them should fetch it.
let isFetching = false;

const useLoadExperimentalFeatures = () => {
  const experimentalFeatures = useSelector(selectors.selectExperimentalFeatures);
  const dispatch = useDispatch();

  useEffect(() => {
    if (experimentalFeatures !== null || isFetching) return;

    isFetching = true;
    makeGet('experimentalFeatures').subscribe(
      ({ response }) => {
        isFetching = false;
        dispatch(actions.loadExperimentalFeaturesSuccess(response));
      },
      () => { isFetching = false; },
    );
  }, [experimentalFeatures, dispatch]);

  const showExperimentalFeature = (experimentalFeature) => {
    // If experimental features are not loaded then we always handle it as experimental feature
    if (experimentalFeatures === null) {
      return false;
    }

    return !experimentalFeatures.includes(experimentalFeature);
  };

  return {
    showExperimentalFeature,
    EXPERIMENTAL_FEATURE_TYPE: constants.EXPERIMENTAL_FEATURE_TYPE,
    experimentalFeaturesLoaded: !!experimentalFeatures
  };
};

export default useLoadExperimentalFeatures;
